import api from '.'

export const assistant = {
  listThreads (trialId, success, fail) {
    api.authenticatedRequest('GET', `/assistant/threads?trialId=${trialId}`, null, success, fail)
  },
  startThread (trialId, success, fail) {
    api.authenticatedRequest('POST', '/assistant/threads', { trialId }, success, fail)
  },
  getThread (threadId, success, fail) {
    api.authenticatedRequest('GET', `/assistant/threads/${threadId}`, null, success, fail)
  },
  deleteThread (threadId, success, fail) {
    api.authenticatedRequest('DELETE', `/assistant/threads/${threadId}`, null, success, fail)
  },
  sendMessage (threadId, message, context, success, fail) {
    api.authenticatedRequest('POST', `/assistant/threads/${threadId}/messages`, { message, context }, success, fail)
  }
}
